import Table from "react-bootstrap/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenClip, faSquare, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { clsx } from "clsx";
import _ from "lodash";
import MovementListItem from "../MovementListItem";
import { Col, Row } from "react-bootstrap";

const dataArrayTable = [
  { title: "#", value: "1", value2: "3. Outstanding Position", width: "100px" },
  { title: "Action", value: "EXISTING", value2: "3. Outstanding Position", width: "100px" },
  { title: "Stock", value: "RAPID SYNERGY BERHAD(7765) ", value2: "3. Outstanding Position", width: "100px" },
  { title: "Qty", value: "62,200", value2: "3. Outstanding Position", width: "100px" },
  { title: "Price", value: "22, 840000", value2: "3. Outstanding Position", width: "100px" },
  { title: "Cap Price", value: "-", value2: "3. Outstanding Position", width: "100px" },
  { title: "Market Value", value: "1,420,648,00", value2: "3. Outstanding Position", width: "100px" },
  { title: "MOF", value: "3.94%", value2: "3. Outstanding Position", width: "100px" },
  { title: "Margin Amount", value: "55,973,53", value2: "3. Outstanding Position", width: "100px" },
  { title: "O/S Amount", value: "-581,801,59", value2: "3. Outstanding Position", width: "100px" },
];
function MarginCalculatorStockMovement({
  handleShow,
  addNewMovement,
  shareMovementList,
  onClickDelete,
  onClickEdit,
}) {
  return (
    <div className="custom-table-margin-simulator-styled">
      <div className={"responsive-table-border table-w-1400"}>
        <Row className="gy-3 flex-column-reverse">
          {_.map(shareMovementList, (item, index) => {
            return (
              <Col xxl={12} xl={12} md={12} key={index} sm={12} xs={12}>
                <MovementListItem
                  index={index}
                  onClickDelete={onClickDelete}
                  onClickEdit={onClickEdit}
                  item={item}
                />
              </Col>
            );
          })}
        </Row>
      </div>
    </div>
  );
}

export default MarginCalculatorStockMovement;
